const globalContext = {
    mobileBreakpoint: 992,
    body: document.body,
    html: document.documentElement,
    iScreenWidth: document.body.getBoundingClientRect().width,
}

export default globalContext;